/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LootBoxInstanceWithConfig } from './LootBoxInstanceWithConfig';
import {
    LootBoxInstanceWithConfigFromJSON,
    LootBoxInstanceWithConfigFromJSONTyped,
    LootBoxInstanceWithConfigToJSON,
    LootBoxInstanceWithConfigToJSONTyped,
} from './LootBoxInstanceWithConfig';
import type { PaginationInfo } from './PaginationInfo';
import {
    PaginationInfoFromJSON,
    PaginationInfoFromJSONTyped,
    PaginationInfoToJSON,
    PaginationInfoToJSONTyped,
} from './PaginationInfo';

/**
 * 
 * @export
 * @interface GetMyLootBoxInstancesResponse
 */
export interface GetMyLootBoxInstancesResponse {
    /**
     * 
     * @type {PaginationInfo}
     * @memberof GetMyLootBoxInstancesResponse
     */
    paginationInfo: PaginationInfo;
    /**
     * 
     * @type {Array<LootBoxInstanceWithConfig>}
     * @memberof GetMyLootBoxInstancesResponse
     */
    lootBoxInstances: Array<LootBoxInstanceWithConfig>;
}

/**
 * Check if a given object implements the GetMyLootBoxInstancesResponse interface.
 */
export function instanceOfGetMyLootBoxInstancesResponse(value: object): value is GetMyLootBoxInstancesResponse {
    if (!('paginationInfo' in value) || value['paginationInfo'] === undefined) return false;
    if (!('lootBoxInstances' in value) || value['lootBoxInstances'] === undefined) return false;
    return true;
}

export function GetMyLootBoxInstancesResponseFromJSON(json: any): GetMyLootBoxInstancesResponse {
    return GetMyLootBoxInstancesResponseFromJSONTyped(json, false);
}

export function GetMyLootBoxInstancesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetMyLootBoxInstancesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'paginationInfo': PaginationInfoFromJSON(json['paginationInfo']),
        'lootBoxInstances': ((json['lootBoxInstances'] as Array<any>).map(LootBoxInstanceWithConfigFromJSON)),
    };
}

export function GetMyLootBoxInstancesResponseToJSON(json: any): GetMyLootBoxInstancesResponse {
    return GetMyLootBoxInstancesResponseToJSONTyped(json, false);
}

export function GetMyLootBoxInstancesResponseToJSONTyped(value?: GetMyLootBoxInstancesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'paginationInfo': PaginationInfoToJSON(value['paginationInfo']),
        'lootBoxInstances': ((value['lootBoxInstances'] as Array<any>).map(LootBoxInstanceWithConfigToJSON)),
    };
}

